



























































import PopularKey from "@/components/PopularKey.vue";
import { PopularItems, PrefixPopularItems, Key, KeyCat, KeyCatUnit } from "@/types/debug-mode";
import GetPopularItems from "@/mixins/get-popular-items";
import GetPrefixPopularItems from "@/mixins/get-prefix-popular-items";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { State } from "vuex-class";

@Component({ components: { PopularKey } })
export default class PopularKeysView extends Mixins(GetPopularItems, GetPrefixPopularItems) {
  created() {
    // Get the key category (hit, missed, mutated) from the route param
    this.keyCat = this.$route.params.keyCat as KeyCat;

    // Determine is view is for overall keys or prefix keys by route name
    // Get data if not cached
    if (this.$route.name === "prefixPopularKeys") {
      this.viewName = "prefixPopularKeys";
      this.getPrefixPopularItems(this.activePrefixID);
    } else {
      this.viewName = "";
      this.getPopularItems();
    }
  }

  // Clean up fetching/caching data
  beforeDestroy() {
    if (this.$route.name === "prefixPopularKeys") {
      this.cleanUpPrefixPopularItems();
    } else {
      this.cleanUpPopularItems();
    }
  }

  // Route param changes are not reactive, so watch for updates
  @Watch("$route")
  onRouteUpdate(to: Route, from: Route) {
    if (to.params.keyCat !== from.params.keyCat) {
      this.keyCat = to.params.keyCat as KeyCat;
    }

    // Only if the route name changes, fetch data if not cached
    if (to.name !== from.name) {
      if (to.name === "prefixPopularKeys") {
        this.viewName = "prefixPopularKeys";
        this.getPrefixPopularItems(this.activePrefixID);
      } else {
        this.viewName = "";
        this.getPopularItems();
      }
    }
  }

  @State(state => state.debugMode.popularItems)
  overallPopularItems!: PopularItems;
  @State(state => state.debugMode.prefixPopularItems)
  prefixPopularItems!: PrefixPopularItems;

  // Only used for prefix keys
  @State("activePrefixID") activePrefixID!: number;

  // Set a view data property so we can react to view name changes
  // and set which popular items values to use (overall or prefix)
  viewName = "";

  keys: null | Key[] = null;
  keyCat: KeyCat = "hit";
  keyCatUnit: KeyCatUnit = "hits";

  get popularItems() {
    if (this.viewName === "prefixPopularKeys") {
      return this.prefixPopularItems[this.activePrefixID];
    }
    return this.overallPopularItems;
  }

  get hit() {
    if (this.keyCat === "hit") {
      this.keys = this.popularItems.most_hit_keys;
      this.keyCatUnit = "hits";
      return true;
    }
    return false;
  }

  get missed() {
    if (this.keyCat === "missed") {
      this.keys = this.popularItems.most_missed_keys;
      this.keyCatUnit = "misses";
      return true;
    }
    return false;
  }

  get mutated() {
    if (this.keyCat === "mutated") {
      this.keys = this.popularItems.most_mutated_keys;
      this.keyCatUnit = "mutations";
      return true;
    }
    return false;
  }

  get hasKeys() {
    return this.keys && this.keys.length > 0;
  }

  get dataReady() {
    return !!this.popularItems;
  }

  get timeSlice() {
    // nanoseconds to seconds
    const secs = this.popularItems.time_slice / 10 ** 9;
    let time = secs;
    let unit = "secs";

    if (secs > 60) {
      time = secs / 60;
      unit = "mins";
    }

    return `${time.toFixed()} ${unit}`;
  }

  get popularityunit() {
    return `${this.keyCatUnit} in last ${this.timeSlice}`;
  }
}
